import type { FormLocale } from '@jlg-website/shared';
import { CheckCircleFilled } from '@/components/pages/icons';
import Cta from '@/components/pages/cta';
import { textFor } from './copy';
import type { CompletionAction } from './type';

type SuccessPanelProps = {
  /** The booked time, already phrased by the flow that booked it. */
  summary: string;
  phone: string;
  locale: FormLocale;
  /** The form's closing button, which only this panel — the end of the flow — may offer. */
  completionAction?: CompletionAction;
};

/** What the visitor sees once a call back is registered, whichever flow booked it. */
export function SuccessPanel({ summary, phone, locale, completionAction }: SuccessPanelProps) {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex w-full flex-col items-center gap-4 py-6 text-center" role="status">
        <CheckCircleFilled className="size-12 text-brand-accent-success" aria-hidden="true" />

        <h2 className="text-xl font-bold text-brand-text-button">
          {textFor(locale, 'successTitle')}
        </h2>

        <p className="w-full text-sm font-semibold text-brand-primary">{summary}</p>

        <p className="text-sm text-gray-light">
          {textFor(locale, 'weWillCall')}{' '}
          <strong className="font-bold text-brand-text-button">{phone}</strong>.{' '}
          {textFor(locale, 'successHint')}
        </p>
      </div>

      {/* The shadow variation is the same chrome the form draws this button with when no
          scheduler replaces it, so the visitor sees one button, not two that nearly match. */}
      {completionAction && (
        <Cta
          type="button"
          variation="shadow"
          size="md"
          className="w-full"
          text={completionAction.label}
          onClick={completionAction.onClick}
        />
      )}
    </div>
  );
}
